module.exports = __webpack_public_path__ + "media/images/admin/magazines/icon_bouquet-f4fadb9ac07b6a4ffdeab8c69360d86f.png";